import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { relayOutlookOAuthResultToOpener } from '@app/shared/utils/outlook-oauth-relay';

/**
 * Public (unguarded) Outlook OAuth redirect target for My Profile Link popup.
 * Azure App Registration redirect URI must match this path.
 */
@Component({
    standalone: true,
    selector: 'app-outlook-oauth-callback',
    template: `
        <div style="font-family:Segoe UI,Arial,sans-serif;padding:32px;color:#333">
            <h3 style="margin:0 0 8px">Connecting Outlook…</h3>
            <p style="margin:0">{{ message }}</p>
        </div>
    `
})
export class OutlookOAuthCallbackComponent implements OnInit {
    message = 'You can close this window and return to My Profile.';

    constructor(private _route: ActivatedRoute) {}

    ngOnInit(): void {
        const code = this._route.snapshot.queryParamMap.get('code');
        const error = this._route.snapshot.queryParamMap.get('error');
        const errorDescription = this._route.snapshot.queryParamMap.get('error_description');

        if (!relayOutlookOAuthResultToOpener(code, error, errorDescription)) {
            this.message = errorDescription || error || 'Outlook sign-in did not complete. Please return to My Profile and try again.';
        }
    }
}
